module.exports = __webpack_public_path__ + "static/illustration-lg-7359bdc6fa244bd60c5778d50cda242f.png";